import styled from "styled-components";
import { Theme } from "../../styles/theme";


export const InputButton = styled.input`
  padding: 10px 20px;
  background-color: ${Theme.colors.cor_azul};
  color: ${Theme.colors.cor_branca};
  border: none;
  border-radius: 15px;
`
